import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { Link } from 'react-router-dom';

const AILightComponent = ({ param1, param2 }) => {  

return (
  <MainLayout>
      <div className='mt-12'>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Gen AI Pricing for Integrated Response</h2>
      </div>
      <div className="flex flex-col items-center justify-center ml-4 mr-4 mt-4 mb-4 text-white text-sm">
        <div>
            <p>Charges for ChatGPT integrated response </p>
            <p>Note - Your Think5Whys Wallet Will Be Charged. You must have at least ₹ 10.00 in your Think5Whys Wallet </p>
        </div>
        <div className='mt-4 text-xl bg-blue-600 w-auto px-4 items-center'>
            <Link to="/wallet-mywallet" className='justify-center'>View Wallet</Link>
        </div>
      </div>
    </MainLayout>
  );
}


export default AILightComponent;

